// Mock data for Ionic Estate Sales

export const navLinks = [
  { label: 'Who We Are', href: '/#vision' },
  { label: 'What We Do', href: '/#capabilities' },
  { label: 'Who We Serve', href: '/#clients' },
  { label: 'Estates Transformed', href: '/#vault' },
  { label: 'Join Our Team', href: '/#join' },
  { label: 'Franchise', href: '/franchise' },
  { label: 'FAQ', href: '/#faq' },
  { label: 'Contact', href: '/#contact' },
];;

export const monolithMarquee = [
  'Estate Sales',
  'Downsizing',
  'Business Liquidation',
  'Appraisals',
  'Staging',
  'Cleanout',
  'Consulting',
  'Close-Out',
];

export const manifestoLines = [
  { k: '01', v: 'Integrity in every decision.' },
  { k: '02', v: 'Professionalism in every interaction.' },
  { k: '03', v: 'Compassion for every client.' },
  { k: '04', v: 'Excellence in execution.' },
];

export const capabilities = [
  {
    number: '01',
    title: 'Consultation',
    kicker: 'Planning & Strategy',
    body: 'Every estate begins with a free consultation. We assess the property, understand your goals, and build a tailored plan that fits the unique needs and circumstances of your family.',
    tags: ['On-Site Visit', 'Estate Assessment', 'Timeline Planning'],
  },
  {
    number: '02',
    title: 'Organization',
    kicker: 'Sorting & Pricing',
    body: 'Our team organizes and prepares every piece, then applies research-driven, market-based pricing so each item is valued accurately and competitively for real buyers.',
    tags: ['Careful Sorting', 'Market Research', 'Fair Pricing'],
  },
  {
    number: '03',
    title: 'Staging & Marketing',
    kicker: 'Presentation & Reach',
    body: 'Professional merchandising and strategic marketing bring qualified buyers through the door. We advertise across premier estate networks, social platforms, and local signage.',
    tags: ['Merchandising', 'Multi-Channel Ads', 'Buyer Networks'],
  },
  {
    number: '04',
    title: 'Sale & Close',
    kicker: 'Execution & Close-Out',
    body: 'We run the sale on-site, or off-site if needed, with a professional team, then coordinate cleanout so you close the chapter with clarity and confidence.',
    tags: ['On-Site Team', 'Cleanout', 'Close-Out Support'],
  },
];

export const estateTransformations = [
  {
    id: 't1',
    number: '01',
    title: 'Portland Heights Family Home',
    location: 'Portland, OR',
    scope: 'Full Estate',
    duration: '3 Days',
    summary: 'A three-generation Craftsman sorted, priced, staged, and marketed \u2014 delivered ready for market in under three weeks.',
    beforeImage: '/portland-heights-before.webp',
    afterImage: '/portland-heights-after.png',
  },
  {
    id: 't2',
    number: '02',
    title: 'Bend Ranch',
    location: 'Bend, Oregon',
    scope: 'Senior Downsizing',
    duration: '2 Days',
    summary: 'A senior transition to assisted living \u2014 sorted, priced, and staged with sensitivity and care.',
    beforeImage: '/ashland-ranch-before.png',
    afterImage: '/ashland-ranch-after.png',
  },
  {
    id: 't3',
    number: '03',
    title: 'Medford Legacy Estate',
    location: 'Medford, OR',
    scope: 'Executor Estate',
    duration: '3 Days',
    summary: 'Coordinated with the trustee and attorney \u2014 fully documented sale details from start to finish.',
    beforeImage: '/medford-legacy-before.png',
    afterImage: '/medford-legacy-after.png',
  },
  {
    id: 't4',
    number: '04',
    title: 'Ashland Retreat',
    location: 'Ashland, Oregon',
    scope: 'Specialty Estate',
    duration: '2 Days',
    summary: 'Regional fine art, silver, and rugs \u2014 research-based pricing and targeted collector outreach.',
    beforeImage: '/vancouver-before.webp',
    afterImage: '/vancouver-after.webp',
  },
  {
    id: 't5',
    number: '05',
    title: 'Sisters Oregon Hideaway',
    location: 'Sisters, OR',
    scope: 'Attorney Referral',
    duration: '3 Days',
    summary: 'A pre-listing clearance in partnership with the listing agent \u2014 turn-key close-out delivered on schedule.',
    beforeImage: '/west-linn-before.webp',
    afterImage: '/west-linn-after.png',
  },
  {
    id: 't6',
    number: '06',
    title: 'Grants Pass Business Liquidation',
    location: 'Grants Pass, OR',
    scope: 'Business Liquidation',
    duration: '5 Days',
    summary: 'A full commercial liquidation \u2014 furniture, fixtures, and equipment cleared with a detailed close-out.',
    beforeImage: '/ashland-business-before.webp',
    afterImage: '/ashland-business-after.webp',
  },
];

export const vaultItems = [
  {
    id: 'v1',
    title: 'Portland Heights Family Estate',
    era: '1912',
    category: 'Full Estate Sale',
    highlight: 'A complete estate liquidation following the loss of a loved one — sorted, priced, staged, and marketed in under three weeks.',
    image: 'https://images.unsplash.com/photo-1513185041617-8ab03f83d6c5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
    stats: [
      { l: 'Pieces', v: '842' },
      { l: 'Sold-Through', v: '96%' },
      { l: 'Duration', v: '3 Days' },
    ],
  },
  {
    id: 'v2',
    title: 'Ashland Downsizing Project',
    era: '1968',
    category: 'Senior Downsizing',
    highlight: 'A senior transition to assisted living. Sensitive, personalized service kept the family stress-free while maximizing value on retained pieces.',
    image: 'https://images.unsplash.com/photo-1596247838521-8b2294dd2b8b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
    stats: [
      { l: 'Pieces', v: '512' },
      { l: 'Sold-Through', v: '98%' },
      { l: 'Duration', v: '2 Days' },
    ],
  },
  {
    id: 'v3',
    title: 'Medford Trust Liquidation',
    era: '1948',
    category: 'Executor Estate',
    highlight: 'Coordinated with the trustee and attorney to deliver a transparent, well-documented sale with clear records at every step.',
    image: 'https://images.unsplash.com/photo-1535905496755-26ae35d0ae54?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
    stats: [
      { l: 'Pieces', v: '1,204' },
      { l: 'Sold-Through', v: '94%' },
      { l: 'Duration', v: '3 Days' },
    ],
  },
  {
    id: 'v4',
    title: 'Vancouver Fine Art Estate',
    era: '1934',
    category: 'Specialty Estate',
    highlight: 'Regional collection with fine art, silver, and rugs. Research-based pricing and targeted collector outreach delivered exceptional results.',
    image: 'https://images.unsplash.com/photo-1600097826494-e7cc6700fc02?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
    stats: [
      { l: 'Pieces', v: '648' },
      { l: 'Sold-Through', v: '99%' },
      { l: 'Duration', v: '2 Days' },
    ],
  },
  {
    id: 'v5',
    title: 'West Linn Real Estate Partner Sale',
    era: '1955',
    category: 'Realtor Referral',
    highlight: 'A pre-listing estate clearance in partnership with the listing agent. Turn-key close-out prepared the home for market on schedule.',
    image: 'https://images.unsplash.com/photo-1605143185597-9fe1a8065fbb?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
    stats: [
      { l: 'Pieces', v: '731' },
      { l: 'Sold-Through', v: '97%' },
      { l: 'Duration', v: '3 Days' },
    ],
  },
  {
    id: 'v6',
    title: 'Ashland Business Liquidation',
    era: '1921',
    category: 'Business Liquidation',
    highlight: 'Full commercial liquidation — furniture, fixtures, and equipment — with detailed close-out on schedule.',
    image: 'https://images.unsplash.com/photo-1611078295948-10b3961e1e40?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
    stats: [
      { l: 'Pieces', v: '2,140' },
      { l: 'Sold-Through', v: '92%' },
      { l: 'Duration', v: '5 Days' },
    ],
  },
];

export const sellerSteps = [
  {
    id: 1,
    label: 'Your Estate',
    prompt: 'Tell us about the property and the services you\u2019re considering.',
    fields: [
      { name: 'estateType', label: 'What best describes your needs?', type: 'select', options: ['Full estate sale', 'Downsizing / senior transition', 'Executor or trustee sale', 'Business liquidation', 'Real estate partner referral', 'Not sure yet'] },
      { name: 'timeframe', label: 'Desired timeframe', type: 'select', options: ['Within 30 days', '1\u20132 months', '3+ months', 'Just exploring'] },
    ],
  },
  {
    id: 2,
    label: 'The Details',
    prompt: 'A bit of context helps us prepare for a productive first conversation.',
    fields: [
      { name: 'era', label: 'Approximate era, style, or notable categories', type: 'text', placeholder: 'e.g. 1950s ranch, mid-century, fine art, silver' },
      { name: 'notes', label: 'Anything we should know?', type: 'textarea', placeholder: 'Notable items, timeline pressures, or family considerations we should be aware of.' },
    ],
  },
  {
    id: 3,
    label: 'How to Reach You',
    prompt: 'A specialist will respond within one business day \u2014 no obligation.',
    fields: [
      { name: 'name', label: 'Your name', type: 'text', required: true },
      { name: 'email', label: 'Email', type: 'email', required: true },
      { name: 'phone', label: 'Phone', type: 'tel' },
      { name: 'location', label: 'City / ZIP', type: 'text' },
    ],
  },
];

export const testimonials = [
  {
    quote: 'From the first walkthrough to the final handoff, Ionic handled our parents\u2019 estate with real professionalism and compassion. What could have been the hardest weekend of our lives became something manageable and even meaningful.',
    name: 'Margaret H.',
    role: 'Family Client',
    estate: 'Portland Heights Family Estate',
  },
  {
    quote: 'Their processes are clearly proven. Every item was sorted, priced fairly, and marketed well. The final numbers exceeded our expectations \u2014 and the communication throughout was exceptional.',
    name: 'Susan & Jim K.',
    role: 'Executors',
    estate: 'Medford Trust Liquidation',
  },
  {
    quote: 'As the trustee, I needed transparency and documentation. Ionic delivered both, along with a smooth on-site experience and clear documentation I could hand straight to the estate attorney.',
    name: 'Angela T.',
    role: 'Trustee',
    estate: 'Bend Ranch',
  },
  {
    quote: 'A gallery, not a garage sale \u2014 that\u2019s what buyers kept saying. The staging and merchandising made every piece look its best. I\u2019d recommend Ionic to any real estate colleague or family in transition.',
    name: 'David R.',
    role: 'Real Estate Partner',
    estate: 'Sisters Oregon Hideaway Referral',
  },
];

export const contactInfo = {
  phone: '(541) 941-4830',
  phoneHref: 'tel:5419414830',
  emailDisplay: 'ionicteam@ionicestatesales.com',
  emailHref: 'mailto:ionicteam@ionicestatesales.com',
  serviceAreas: ['Southern Oregon', 'Portland', 'Vancouver', 'Ashland', 'Medford'],
  socials: [
    { name: 'Facebook', href: 'https://www.facebook.com/ionicestatesales' },
    { name: 'Instagram', href: 'https://www.instagram.com/ionicestatesales' },
    { name: 'X', href: 'https://www.x.com/ionicestatesale' },
    { name: 'TikTok', href: 'https://www.tiktok.com/@ionicestatesales' },
    { name: 'YouTube', href: 'https://www.youtube.com/@IONICESTATESALES' },
  ],
};

export const joinTeamOptions = [
  {
    id: 'team',
    number: '01',
    kicker: 'Careers',
    title: 'Work With Ionic',
    body: 'Join a team of estate professionals delivering exceptional service on every project. We hire specialists who bring integrity, craft, and care to every client interaction.',
    benefits: [
      'Full-time and project-based positions',
      'Ongoing training in our proven systems',
      'Meaningful work supporting real families',
      'Competitive compensation and growth',
    ],
    cta: 'Apply to Join',
    leadKey: 'ionic_team_leads',
    formTitle: 'Apply to the Ionic team',
    formBlurb: 'Tell us a little about yourself and how you\u2019d like to contribute.',
    fields: [
      { name: 'name', label: 'Full name', type: 'text', required: true },
      { name: 'email', label: 'Email', type: 'email', required: true },
      { name: 'phone', label: 'Phone', type: 'tel' },
      { name: 'location', label: 'City / State', type: 'text' },
      { name: 'role', label: 'Role of interest', type: 'select', options: ['On-site sale team', 'Merchandising & staging', 'Appraisal & pricing', 'Marketing & photography', 'Operations & logistics', 'Not sure yet'] },
      { name: 'message', label: 'A little about you', type: 'textarea', placeholder: 'Background, availability, or a link to your resume.' },
    ],
  },
];

export const faqs = [
  {
    q: 'How long does the estate sale process typically take?',
    a: 'Most full estate sales take 2\u20134 weeks from initial consultation to sale day \u2014 depending on the size of the estate, condition of the property, and timeline you need. We build a plan around your schedule at the first walkthrough.',
  },
  {
    q: 'What commission or fees do you charge?',
    a: 'That\u2019s a great question! Every estate is unique, so we tailor our services and pricing to your specific needs. Factors such as the size and complexity of the estate, timeline, cleanout needs, off-site services, and overall scope of work are considered.\n\nDepending on your situation, we may offer a commission-based structure, flat-rate service, buyout, or another customized solution. Our goal is to determine the approach that works best for you and your estate.',
  },
  {
    q: 'What kinds of items typically sell well?',
    a: 'Nearly everything sells at the right price: vehicles, furniture, art, jewelry, silver, china, rugs, tools, collectibles, kitchenware, books, garden pieces, clothing including vintage clothing, and quality decor. Even everyday household goods find buyers when merchandised properly.',
  },
  {
    q: 'What doesn\u2019t sell \u2014 or shouldn\u2019t be included?',
    a: 'Leave it all to us. Please don\u2019t donate, discard, or pre-sort items before we arrive. During our walkthrough, we\u2019ll identify what can be sold, donated, recycled, or responsibly disposed of \u2014 and coordinate it for you. Nothing needs to be decided before we do the work.',
  },
  {
    q: 'How is pricing determined?',
    a: 'Every piece is researched using current market comparables, auction records, and category expertise. We aim for fair market value \u2014 competitive enough to sell, high enough to maximize what your estate earns.',
  },
  {
    q: 'Do I need to be present during the sale?',
    a: 'No. To ensure a successful event, we require the home to be unoccupied by family or residents during the prep work and sale dates. Our professional team runs the entire sale on-site \u2014 greeting shoppers, negotiating, and processing every transaction.',
  },
  {
    q: 'What if there are heirlooms or items the family wants to keep?',
    a: 'Simply tag or set them aside before we begin sorting. We work with you to identify what\u2019s staying with the family, being distributed to heirs, or sold. Nothing is included in the sale without your approval.',
  },
  {
    q: 'Do you handle cleanout after the sale?',
    a: 'Yes. Post-sale, we coordinate donation pickups and property cleanout so you receive the keys back turn-key ready! You can also coordinate your own cleanout.',
  },
];

export const idealClients = [
  {
    number: '01',
    icon: 'Users',
    title: 'Families in Transition',
    body: 'Managing an estate after the loss of a loved one \u2014 we bring compassion, discretion, and a proven plan.',
  },
  {
    number: '02',
    icon: 'FileText',
    title: 'Executors & Trustees',
    body: 'Transparent process, market-based pricing, and clear documentation ready for your attorney.',
  },
  {
    number: '03',
    icon: 'Heart',
    title: 'Seniors Downsizing',
    body: 'Transitioning to assisted living or a smaller home. We move at your pace with care and respect.',
  },
  {
    number: '04',
    icon: 'Key',
    title: 'Real Estate Professionals',
    body: 'Pre-listing clearance that prepares the home for market on schedule \u2014 turn-key for you and your seller.',
  },
  {
    number: '05',
    icon: 'Scale',
    title: 'Attorneys & Financial Pros',
    body: 'Documented, defensible, and audit-ready. We support probate, trust, and financial-planning outcomes.',
  },
  {
    number: '06',
    icon: 'User',
    title: 'Individual Clients',
    body: 'Anyone seeking a professional partner to handle estate liquidation with integrity and results.',
  },
];

export const heroStats = [
  { value: '30+', label: 'Years of Industry Experience' },
  { value: '1200+', label: 'Estates Successfully Liquidated' },
  { value: '100%', label: 'Full-service, beginning to end' },
];
